import { Suggestion } from './Suggestion';

export interface SuggestionForBusinessReport extends Suggestion {
  projectNumber: string; // プロジェクトナンバー
}

export const EmptySuggestionForBusinessReport: SuggestionForBusinessReport = {
  label: '',
  value: 0,
  code: '',
  projectNumber: '',
};
